import React from 'react';
import { useSelector } from 'react-redux';

interface I18nProviderProps {
  children: React.ReactNode;
}

export const I18nProvider: React.FC<I18nProviderProps> = ({ children }) => {
  const language = useSelector((state: any) => state.i18n.language);
  
  React.useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  return <>{children}</>;
}; 